module.exports = __webpack_public_path__ + "icon_services_status_clear.3747d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_services_status_clear.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_services_status_clear.svg
// module chunks = main